import React, { useEffect, useRef } from "react";
import { List, ListItem } from "@material-ui/core";

function ProList(_a) {
  var options = _a.options,
      selected = _a.selected,
      onSelect = _a.onSelect,
      renderOption = _a.renderOption;
  var listRef = useRef(null);
  useEffect(function () {
    if (listRef && listRef.current && options.length && selected) {
      var option = options.find(function (item) {
        return item.value === selected;
      });

      if (option) {
        var idx = options.indexOf(option);
        var element = listRef.current.querySelector("#option-index-".concat(idx));

        if (element) {
          listRef.current.scrollTop = element.offsetTop - 40;
        }
      }
    }
  }, []);
  return React.createElement(List, {
    ref: listRef,
    style: {
      maxHeight: 300,
      overflow: "auto"
    }
  }, options.map(function (item, idx) {
    return React.createElement(ListItem, {
      selected: selected === item.value,
      key: idx,
      id: "option-index-".concat(idx),
      onMouseDown: function onMouseDown() {
        onSelect(item);
      },
      button: true
    }, renderOption ? renderOption(item) : item.label);
  }));
}

export default ProList;